/**
 * AI Fire API
 * API to access AI Fire sensor data
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Address from './Address';
import FireDepartmentBase from './FireDepartmentBase';

/**
 * The FireDepartment model module.
 * @module model/FireDepartment
 * @version 1.1.0
 */
class FireDepartment {
    /**
     * Constructs a new <code>FireDepartment</code>.
     * A fire department reference record
     * @alias module:model/FireDepartment
     * @implements module:model/FireDepartmentBase
     * @param name {String} 
     * @param email {String} 
     * @param phoneNumber {String} 
     * @param address {module:model/Address} 
     */
    constructor(name, email, phoneNumber, address) { 
        FireDepartmentBase.initialize(this);
        FireDepartment.initialize(this, name, email, phoneNumber, address);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, name, email, phoneNumber, address) { 
        obj['name'] = name;
        obj['email'] = email;
        obj['phoneNumber'] = phoneNumber;
        obj['address'] = address;
    }

    /**
     * Constructs a <code>FireDepartment</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FireDepartment} obj Optional instance to populate.
     * @return {module:model/FireDepartment} The populated <code>FireDepartment</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FireDepartment();
            FireDepartmentBase.constructFromObject(data, obj);

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('phoneNumber')) {
                obj['phoneNumber'] = ApiClient.convertToType(data['phoneNumber'], 'String');
            }
            if (data.hasOwnProperty('address')) {
                obj['address'] = ApiClient.convertToType(data['address'], Address);
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'String');
            }
            if (data.hasOwnProperty('timeLastUpdated')) {
                obj['timeLastUpdated'] = ApiClient.convertToType(data['timeLastUpdated'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>FireDepartment</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FireDepartment</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of FireDepartment.RequiredProperties) {
            if (!data.hasOwnProperty(property)) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['phoneNumber'] && !(typeof data['phoneNumber'] === 'string' || data['phoneNumber'] instanceof String)) {
            throw new Error("Expected the field `phoneNumber` to be a primitive type in the JSON string but got " + data['phoneNumber']);
        }
        // validate the optional field `address`
        if (data['address']) { // data not null
          Address.validateJSON(data['address']);
        }
        // ensure the json data is a string
        if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
            throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
        }

        return true;
    }


}

FireDepartment.RequiredProperties = ["name", "email", "phoneNumber", "address"];

/**
 * @member {String} name
 */
FireDepartment.prototype['name'] = undefined;

/**
 * @member {String} email
 */
FireDepartment.prototype['email'] = undefined;

/**
 * @member {String} phoneNumber
 */
FireDepartment.prototype['phoneNumber'] = undefined;

/**
 * @member {module:model/Address} address
 */
FireDepartment.prototype['address'] = undefined;

/**
 * @member {String} id
 */
FireDepartment.prototype['id'] = undefined;

/**
 * @member {Date} timeLastUpdated
 */
FireDepartment.prototype['timeLastUpdated'] = undefined;


// Implement FireDepartmentBase interface:
/**
 * @member {String} name
 */
FireDepartmentBase.prototype['name'] = undefined;
/**
 * @member {String} email
 */
FireDepartmentBase.prototype['email'] = undefined;
/**
 * @member {String} phoneNumber
 */
FireDepartmentBase.prototype['phoneNumber'] = undefined;
/**
 * @member {module:model/Address} address
 */
FireDepartmentBase.prototype['address'] = undefined;




export default FireDepartment;

